<template>
  <v-icon
    v-if="value === true"
    color="d-green"
  >
    mdi-check
  </v-icon>
</template>


<script>
export default {
  inheritAttrs: false,


  props: {
    value: {
      type: Boolean
    }
  }
}
</script>
